
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register-phone",
      function () {
        return require("private-next-pages/register-phone/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/register-phone"])
      });
    }
  